import * as React from "react";

export function Ico20ArrowRight({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.85156 15.6611L12.9256 10.1945C13.0405 10.0911 13.0405 9.91086 12.9256 9.80741L6.85156 4.34082"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
